import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Media} from '../../core/definitions/media';
import {SuperObjectModel} from '../../core/definitions/super-object-model';
import {isMediaNotReady, mediaThumbnailFallbackIcon} from '../../shared/thumbnail-fallback-icon';
import {MediaConversionWatcher} from '../../shared/media-conversion-watcher.service';

@Component({
    selector: 'app-thumbnail-carousel',
    templateUrl: './thumbnail-carousel.component.html',
    styleUrls: ['./thumbnail-carousel.component.scss'],
    standalone: false
})
export class ThumbnailCarouselComponent {
  private readonly conversionWatcher = inject(MediaConversionWatcher, {optional: true});
  // Keyed by url, so a tile recovers when its $$thumbUrl changes
  private readonly invalidSrcs = new Set<string>();
  @Input() media: Media[];
  @Input() mediaIndex: number;
  @Input() currentMediaType;
  @Input() thumbnailWidth;
  @Output() setActiveImg = new EventEmitter<object>();
  protected readonly mediaFallbackIcon = mediaThumbnailFallbackIcon;
  // While the media converts the tile shows the hourglass, also over an image that loads (the audio placeholder)
  protected readonly isNotReady = isMediaNotReady;

  public setMedia(index) {
    const mediaIndex = {
      index: index
    };
    this.setActiveImg.emit(mediaIndex);
  }

  onThumbnailError(media: SuperObjectModel) {
    this.setInvalidSrc(media.$$thumbUrl);
    this.conversionWatcher?.watch(media);
  }

  setInvalidSrc(url: string) {
    this.invalidSrcs.add(url);
  }

  isInvalidSrc(url: string): boolean {
    return this.invalidSrcs.has(url);
  }
}
